import { getStatusLabel } from "@/utils/get-status-label";

export function getSituacaoColorClass(situacao: string): string {
  switch (situacao) {
    case "Pendente":
      return "bg-orange-500 text-white";
    case "Solicitado":
      return "bg-white text-black";
    case "Em produção":
      return "bg-blue-100 text-blue-700";
    case "Em aprovação":
      return "bg-yellow-500 text-white";
    case "pronto para imprimir":
      return "bg-blue-500 text-white";
    case "Pronto para imprimir":
      return "bg-blue-500 text-white";
    case "Envio de dados":
      return "bg-blue-500 text-white";
    case "Concluída":
      return "bg-green-500 text-white";
    case "Pedido liberado":
      return "bg-green-500 text-white";
    case "ativo":
      return "bg-green-500 text-white";
    case "Confirmado":
      return "bg-green-500 text-white";
    case "Concluído":
      return "bg-green-500 text-white";
    case "Conferido":
      return "bg-blue-500 text-white";
    case "Cancelada":
      return "bg-red-500 text-white";
    case "Cancelado":
      return "bg-red-500 text-white";
    case "Inativo":
      return "bg-red-500 text-white";
    case "Saida":
      return "bg-red-500 text-white";
    case "saida":
      return "bg-red-500 text-white";
    case "entrada":
      return "bg-green-500 text-white";

    case "0 dia":
      return "bg-neutral-300 text-black";
    case "2 dias":
      return "bg-green-500 text-white";
    case "3 dias":
      return "bg-yellow-500 text-white";
    case "4 dias":
      return "bg-red-500 text-white";
    case "5 dias":
      return "bg-red-500 text-white";
    case "6 dias":
      return "bg-red-500 text-white";

    default:
      return "bg-neutral-300 text-black";
  }
}

export function getSituacaoColorBySlug(slug: string): string {
  return getSituacaoColorClass(getStatusLabel(slug));
}
